import { useTranslation } from 'react-i18next';

import { DataPanelAutoWrapInlineItem } from '@/ui';
import { openEditDispatcherNoteDialog } from '../../actions';

export type SummaryPanelItemProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  note: string | null;
};

export function SummaryPanelItem({ incidentId, incidentIsReadOnly, note }: SummaryPanelItemProps) {
  const { t } = useTranslation();

  return (
    <DataPanelAutoWrapInlineItem
      title={t('Incident_InfoPanel_DispatcherNote')}
      value={note ?? undefined}
      editable={!incidentIsReadOnly}
      showEmptyPlaceholder
      onEditClick={() => openEditDispatcherNoteDialog(incidentId, note)}
    />
  );
}
